var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSphereBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 356 357"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "26.123%",
    cy: "37.366%",
    fx: "26.123%",
    fy: "37.366%",
    r: "62.861%",
    id: "sphere-bottom_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D78",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101A2C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-92.8%",
    y: "-88%",
    width: "285.5%",
    height: "285.5%",
    filterUnits: "objectBoundingBox",
    id: "sphere-bottom_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.725490196 0 0 0 0 0.894117647 0 0 0 0 0.890196078 0 0 0 0.234320367 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "sphere-bottom_svg__b",
    cx: 227,
    cy: 615.5,
    r: 83
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49 -445)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#sphere-bottom_svg__a)",
    xlinkHref: "#sphere-bottom_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#sphere-bottom_svg__c)",
    xlinkHref: "#sphere-bottom_svg__b"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzU2cHgiIGhlaWdodD0iMzU3cHgiIHZpZXdCb3g9IjAgMCAzNTYgMzU3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPk92YWwgQ29weSA4PC90aXRsZT4KICAgIDxkZWZzPgogICAgICAgIDxyYWRpYWxHcmFkaWVudCBjeD0iMjYuMTIyNTg3MSUiIGN5PSIzNy4zNjYxMTM1JSIgZng9IjI2LjEyMjU4NzElIiBmeT0iMzcuMzY2MTEzNSUiIHI9IjYyLjg2MDgyMjklIiBpZD0icmFkaWFsR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM0OTVENzgiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzEwMUEyQyIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9yYWRpYWxHcmFkaWVudD4KICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTIiIGN4PSIyMjciIGN5PSI2MTUuNSIgcj0iODMiPjwvY2lyY2xlPgogICAgICAgIDxmaWx0ZXIgeD0iLTkyLjglIiB5PSItODguMCUiIHdpZHRoPSIyODUuNSUiIGhlaWdodD0iMjg1LjUlIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIGlkPSJmaWx0ZXItMyI+CiAgICAgICAgICAgIDxmZU9mZnNldCBkeD0iMCIgZHk9IjgiIGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiPjwvZmVPZmZzZXQ+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjUwIiBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiPjwvZmVHYXVzc2lhbkJsdXI+CiAgICAgICAgICAgIDxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwLjcyNTQ5MDE5NiAgIDAgMCAwIDAgMC44OTQxMTc2NDcgICAwIDAgMCAwIDAuODkwMTk2MDc4ICAwIDAgMCAwLjIzNDMyMDM2NyAwIiB0eXBlPSJtYXRyaXgiIGluPSJzaGFkb3dCbHVyT3V0ZXIxIj48L2ZlQ29sb3JNYXRyaXg+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iT3ZhbC1Db3B5LTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OS4wMDAwMDAsIC00NDUuMDAwMDAwKSI+CiAgICAgICAgICAgIDx1c2UgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIgZmlsdGVyPSJ1cmwoI2ZpbHRlci0zKSIgeGxpbms6aHJlZj0iI3BhdGgtMiI+PC91c2U+CiAgICAgICAgICAgIDx1c2UgZmlsbD0idXJsKCNyYWRpYWxHcmFkaWVudC0xKSIgZmlsbC1ydWxlPSJldmVub2RkIiB4bGluazpocmVmPSIjcGF0aC0yIj48L3VzZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgSphereBottom as ReactComponent };